// extracted by mini-css-extract-plugin
export default {"ribbon":"InformaPingIdentityRibbon_ribbon__U6VOh","container":"InformaPingIdentityRibbon_container__6SGmt","userActions":"InformaPingIdentityRibbon_userActions__3q3wV"};